"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWorkingCapitalWidget = void 0;
var React = require("react");
var ApLoaderDefault_1 = require("../../ApLoaderDefault");
var ApLoaderText_1 = require("../../ApLoaderText");
var ApWidgetBigValue_1 = require("../ApWidgetBigValue");
var ApWidgetBullet_1 = require("../ApWidgetBullet");
var ApWidgetCard_1 = require("../ApWidgetCard");
var ApWidgetChangeOverTime_1 = require("../ApWidgetChangeOverTime");
var ApWidgetChart_1 = require("../ApWidgetChart");
var ApWidgetErrorMessage_1 = require("../ApWidgetErrorMessage");
var ApWidgetName_1 = require("../ApWidgetName");
var ApWidgetValueType1_1 = require("../ApWidgetValueType1");
var theme_1 = require("../../../utils/theme");
var styles_1 = require("./styles");
exports.ApWorkingCapitalWidget = function (_a) {
    var _b = _a.config, config = _b === void 0 ? { name: '' } : _b, data = _a.data, dataError = _a.dataError, props = __rest(_a, ["config", "data", "dataError"]);
    return (React.createElement(ApWidgetCard_1.ApWidgetCard, __assign({}, props),
        React.createElement(styles_1.Container, null,
            config && (React.createElement(ApWidgetName_1.ApWidgetName, { name: config.name, iconType: config.iconType })),
            dataError ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApWidgetErrorMessage_1.ApWidgetErrorMessage, null))) : !data ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApLoaderDefault_1.ApLoaderDefault, { loaderText: function () { return React.createElement(ApLoaderText_1.ApLoaderText, null); } }))) : (React.createElement(styles_1.BodyWrapper, null,
                React.createElement(styles_1.LeftContentWrapper, null,
                    React.createElement(styles_1.VarianceContainer, null,
                        React.createElement(styles_1.AverageHighlight, { color: data.variance.value < 1 || data.variance.value > 3
                                ? theme_1.colors.amber
                                : theme_1.colors.green0 },
                            React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, null, data.variance.value)),
                        React.createElement(ApWidgetChangeOverTime_1.ApWidgetChangeOverTime, { value: data.variance.compare, trend: data.variance.trend, label: "On previous period" })),
                    React.createElement(styles_1.AverageContainer, null,
                        React.createElement(ApWidgetValueType1_1.ApWidgetValueType1, { label: "Current assets", value: data.currentAssets }),
                        React.createElement(ApWidgetValueType1_1.ApWidgetValueType1, { label: "Current liabilities", value: data.currentLiabilities })),
                    React.createElement(ApWidgetBullet_1.ApWidgetBulletList, { list: [
                            data.timePeriod,
                            data.viewType,
                            data.taxonomyType + " taxonomy",
                        ] })),
                config && config.widthRatio === 2 ? (React.createElement(styles_1.ChartWrapper, null,
                    React.createElement(ApWidgetChart_1.ApWidgetChart, { data: data.chartData }))) : null)))));
};
exports.ApWorkingCapitalWidget.defaultProps = {
    config: {
        name: '',
    },
    data: null,
};
//# sourceMappingURL=ApWorkingCapitalWidget.js.map